import request from "@/utils/request"
/**
 * 获取广告图
 * @returns Promise
 */

/* 

//获取视频推荐
export const findVideoRecommand = (clID) => {
  return request('/video/recommend', 'get', { clID })
} */

//账户密码登录
export const useAccountLogin = ({ account, password }) => {
  return request('/user/accountlogin', 'post', { account, password })
}
//发送短信验证码

export const sendPhoneCode = (phone) => {
  return request('/user/phonecode', 'get', { phone })
}

//验证码登录
export const usePhoneLogin = ({ phone, code }) => {
  return request('/user/phonelogin', 'post', { phone, code })
}

//点击注册
export const useRegister = ({ phone, code, password }) => {
  return request('/user/register', 'post', { phone, code, password })
}

//校验用户名唯一性
export const userPhoneCheck = (phone) => {
  return request('/user/checkphone', 'get', { phone })
}

//获取修改用户信息
export const getInfoUpdate = ({ id }) => {
  return request(`/user/getupdate?id=${id}`, 'get', {})
}

//checkout页面用户信息修改
export const upInfoUpdate = ({ nickName, phone, address, id }) => {
  return request(`/user/infoupdate?id=${id}`, 'put', { nickName, phone, address })
}

//checkout页面用户信息修改
export const postUserTicket = ({ ticketName, ticketCode, ticketAddress, ticketBank, id }) => {
  return request(`/user/ticket?id=${id}`, 'post', { ticketName, ticketCode, ticketAddress, ticketBank })
}

//checkout页面用户信息修改
export const updateUserMaID = ({ maID, userID }) => {
  return request(`/user/maidupdate?id=${userID}`, 'put', { maID })
}

//个人页面用户信息修改
export const updateUserInfo = ({ userID, nickName, image, address, ticketName, ticketCode, ticketAddress, ticketBank }) => {
  return request(`/user/update?id=${userID}`, 'put', { nickName, image, address, ticketName, ticketCode, ticketAddress, ticketBank })
}

